import { Grid, Segment, Header, Icon, Label, Image } from "semantic-ui-react";
import React, { useState } from "react";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import Select from "components/Form/Select";
import { Formik, Form, Field } from "formik";
import DatePicker from "react-datepicker";
import { MapInteractionCSS } from "react-map-interaction";
import { isMobile } from "utils/isMobile";
import * as Yup from "yup";

const styles = {
	crossRequired: {
		color: "#c5190e",
		fontSize: "1em",
		position: "relative",
		bottom: 1,
		left: 3,
	},
};

const schemaValidation = (deposit_places) =>
	Yup.object().shape({
		numSeq: Yup.string().when("prel_place", {
			is: (val) =>
				(!!deposit_places &&
					deposit_places.some((p) => p.abbreviation === val) &&
					!deposit_places.filter((p) => p.abbreviation === val)[0].numSeqNotRequiredForDeposit) === true,

			then: Yup.string()
				.required("Champ requis")
				.test("numSeq", "Le numéro séquentiel doit être composé de 8 chiffres", (value) => {
					if (!value || value === undefined) return false;
					return value?.length === 8 && value?.match(new RegExp("^[0-9]{8}$"));
				}),
			otherwise: Yup.string()
				.nullable()
				.optional()
				.test("numSeq", "Le numéro séquentiel doit être composé de 8 chiffres", (value) => {
					if (!value || value === undefined) return true;
					return value?.length === 8 && value?.match(new RegExp("^[0-9]{8}$"));
				}),
		}),
	});

const Deposit = ({ deposit, folderId, samplers, places, disabled, submit, fpa }) => {
	const [prelDate, setPrelDate] = useState(deposit && deposit.prel_date ? new Date(deposit.prel_date) : null);
	const [fileIndex, setFileIndex] = useState(0);
	const [rotation, setRotation] = useState(0);

	const b64toBlob = (b64Data, contentType) => {
		var byteCharacters = atob(b64Data);

		var byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
			var slice = byteCharacters.slice(offset, offset + 512),
				byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};
	return (
		<div>
			<Grid.Row columns={1} style={{ margin: -20 }}>
				<Grid.Column>
					<Formik
						enableReinitialize
						validationSchema={schemaValidation(places)}
						initialValues={{
							domicile: deposit?.domicile || "",
							externalSampler: deposit?.sampler?.code_sil || "",
							rdv: deposit?.rdv || "",
							numSeq: deposit?.numSeq || "",
							prel_place: deposit?.prel_place.abbreviation || "",
						}}
						onSubmit={(values) => {
							values.prel_date = prelDate;
							submit(values, folderId);
						}}
					>
						{({ submitForm, dirty, errors, values, touched }) => {
							return (
								<Form>
									<Segment>
										<Header as="h3" textAlign="left">
											Informations sur le dépôt
										</Header>
										<fieldset
											onMouseLeave={() => {
												if (dirty) {
													submitForm();
												}
											}}
										>
											<Segment.Group horizontal>
												<Segment attached style={{ minWidth: "250px" }}>
													<Grid.Column>
														<Field
															component={Select}
															name="externalSampler"
															customlabel="Préleveur"
															placeholder="Préleveur externe"
															options={
																samplers && samplers.length > 0
																	? samplers.map((sampler) => ({
																			value: sampler.code_sil,
																			label: `${sampler.code_sil} - ${sampler.name}`,
																	  }))
																	: [
																			{ label: "DRE - Docteur externe", value: "DRE" },
																			{ label: "IE - Infirmier externe", value: "IE" },
																			{ label: "BNLACREER - Préleveur Bionext à créer", value: "BNLACREER" },
																	  ]
															}
															required
															disabled={disabled}
														/>
														<div>
															Date et heure de prélèvement<span style={styles.crossRequired}>*</span>{" "}
															<DatePicker
																selected={prelDate}
																showTimeSelect
																timeFormat={process.env.REACT_APP_TIME_DISPLAY_FORMAT}
																timeIntervals={5}
																timeCaption="time"
																dateFormat={`${process.env.REACT_APP_DATE_DATEPICKER}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`}
																locale="fr"
																className="custom-input"
																calendarClassName="calendar-container"
																required
																disabled={disabled}
																onChange={(date) => {
																	setPrelDate(date);
																}}
															/>
														</div>

														<Field
															component={Select}
															name="prel_place"
															customlabel="Lieu de prélèvement"
															placeholder="Lieu de prélèvement"
															options={
																places && places.length > 0
																	? places.map((deposit_place) => ({
																			value: deposit_place.abbreviation,
																			label: `${deposit_place.abbreviation} - ${deposit_place.name}`,
																	  }))
																	: [
																			{ label: "En centre", value: "CENTRE" },
																			{ label: "Dr Cabin", value: "CAB" },
																			{ label: "A domicile", value: "DOM" },
																	  ]
															}
															required
															disabled={disabled}
														/>

														<Field
															component={CustomInputTextComponent}
															autoFocus
															autoComplete="off"
															customlabel="Numéro séquentiel"
															type="text"
															name="numSeq"
															style={{ maxWidth: "200px" }}
															required={
																values.prel_place &&
																places &&
																places.filter((p) => p.abbreviation === values.prel_place).length > 0 &&
																places.filter((p) => p.abbreviation === values.prel_place)[0].numSeqNotRequiredForDeposit
																	? false
																	: true
															}
															disabled={disabled}
														/>
														{values.prel_place &&
															places &&
															places.filter((p) => p.abbreviation === values.prel_place).length > 0 &&
															places.filter((p) => p.abbreviation === values.prel_place)[0].requireTypeDomicile && (
																<>
																	<Field
																		component={Select}
																		name="domicile"
																		customlabel="Domicile"
																		placeholder="Domicile"
																		options={[
																			{ label: "Prescrit", value: "PRESCR" },
																			{ label: "Demande patient", value: "PATIENT" },
																		]}
																		required
																		disabled={disabled}
																	/>
																	<Field
																		component={Select}
																		name="rdv"
																		customlabel="Rendez-vous"
																		placeholder="Type de rendez-vous"
																		options={[
																			{ label: "Attribué par le laboratoire au partenaire", value: "LABO" },
																			{ label: "Pris en direct avec le partenaire et dépôt au labo", value: "PARTNER" },
																		]}
																		required
																		disabled={disabled}
																	/>
																</>
															)}
													</Grid.Column>
												</Segment>
												{fpa && fpa.length > 0 && (
													<Segment>
														<Grid>
															<Grid.Row>
																<Grid.Column>
																	<Header as="h3" textAlign="left">
																		{fpa.length === 1 ? "Fiche pré-analytique" : `${fpa.length} fiches pré-analytiques`}
																	</Header>

																	{fpa && fpa.length > 0 && (
																		<>
																			{fpa[fileIndex] &&
																				(fpa[fileIndex].type === "image/png" ||
																					fpa[fileIndex].type === "image/jpg" ||
																					fpa[fileIndex].type === "image/jpeg") && (
																					<div
																						style={{
																							padding: isMobile() ? "5px" : "10px 50px",
																							backgroundColor: "#d3d3d33b",
																							height: "100%",
																							maxHeight: "90vh",
																						}}
																					>
																						<div>
																							{fpa[fileIndex].base64_back && (
																								<Label as="div" color="teal">
																									<Icon name="file alternate" /> Recto-verso
																								</Label>
																							)}
																							<MapInteractionCSS minScale={0.8} maxScale={3} showControls={true}>
																								<Image
																									style={{ transform: `rotate(${rotation})` }}
																									src={`data:${fpa[fileIndex].type ?? "image/png"};charset=utf-8;base64,${fpa[fileIndex].base64}`}
																									onContextMenu={(e) => e.preventDefault()}
																								/>
																							</MapInteractionCSS>
																						</div>
																						{fpa[fileIndex].base64_back && (
																							<div>
																								<MapInteractionCSS minScale={1} maxScale={3} showControls={true}>
																									<Image
																										style={{ transform: `rotate(${rotation})` }}
																										src={`data:${fpa[fileIndex].type ?? "image/png"};charset=utf-8;base64,${
																											fpa[fileIndex].base64_back
																										}`}
																										onContextMenu={(e) => e.preventDefault()}
																									/>
																								</MapInteractionCSS>
																							</div>
																						)}
																					</div>
																				)}

																			{fpa[fileIndex] && fpa[fileIndex].type === "application/pdf" && (
																				<iframe
																					id="fpaDisabled"
																					src={
																						URL.createObjectURL(b64toBlob(fpa[fileIndex].base64, "application/pdf")) +
																						`#toolbar=1&zoom=125&navpanes=0`
																					}
																					title={fpa[fileIndex].filename}
																					name={fpa[fileIndex].filename}
																					style={{ width: "100%", height: "100vh" }}
																				></iframe>
																			)}
																		</>
																	)}
																</Grid.Column>
															</Grid.Row>
														</Grid>
													</Segment>
												)}
											</Segment.Group>{" "}
										</fieldset>
									</Segment>
								</Form>
							);
						}}
					</Formik>
				</Grid.Column>
			</Grid.Row>
		</div>
	);
};

export default Deposit;
